import { HiMiniBolt } from 'react-icons/hi2';
import { PiChatCircle } from 'react-icons/pi';
import { classes } from 'src/modules/shared/utils/styles.util';

interface QuickTemplateIconProps {
  className?: string;
  accentClassName?: string;
  accentBackgroundClassName?: string;
}

export const QuickTemplateIcon = ({
  className,
  accentClassName,
  accentBackgroundClassName,
}: QuickTemplateIconProps) => {
  return (
    <span
      className={classes(
        'relative inline-flex h-5 w-5 shrink-0 items-center justify-center',
        className
      )}
      aria-hidden="true"
    >
      <PiChatCircle className="h-full w-full" />

      <span
        className={classes(
          'absolute -bottom-[0.1rem] -right-[0.2rem] flex h-[0.72rem] w-[0.72rem] items-center justify-center rounded-full bg-primary-50 transition-colors duration-200 group-hover:bg-primary-100 group-active:bg-primary-200',
          accentBackgroundClassName
        )}
      >
        <HiMiniBolt className={classes('h-full w-full', accentClassName)} />
      </span>
    </span>
  );
};
